<template>
	<div>
		<div class="doctorPage doctorSeach">
			<div class="selectSearch">
				<el-form ref="form" :model="statisticsParameter" class="qcFrom" :inline="true">
					<el-form-item label="创建时间">
						<el-date-picker class="time mar4" v-model="pickerDate.date" @change="datePicker"
							type="monthrange" size="mini" range-separator="至" start-placeholder="开始时间"
							end-placeholder="结束时间" value-format="yyyy/MM" format="yyyy-MM"></el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="search" round>查询</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div v-loading="loading">
				<div v-if="expertScoreStatisticList.Experts&&expertScoreStatisticList.Experts.length>0">
					<div class="centerHome marb12">
						<div class="ccHomel">
							<div class="compentTable">
								<div class="boxplotChart" style="width:100%; height:380px">
									<div id="boxplotChart" style="width: 100%;height: 100%;"></div>
								</div>
							</div>
						</div>
					</div>
					<div class="centerHome">
						<div class="ccHomel">
							<div class="compentTable">
								<div class="lineChart" style="width:100%; height:286px">
									<div id="lineChart" style="width: 100%;height: 100%;"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else>
					<nodata-img></nodata-img>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapActions,
		mapMutations
	} from 'vuex';
	import echarts from 'echarts';
	import dataTool from 'echarts/extension/dataTool';
	import nodataImg from '@/components/Common/noDataImg';
	export default {
		data() {
			return {
				pickerDate: {},
				echartsOption: {
					axisLine: {
						show: true,
						lineStyle: {
							color: '#3D4049'
						}
					},
					xAxisAxisLabel: {
						interval: 0,
						rotate: 30,
						textStyle: {
							color: '#fff'
						}
					},
					yAxisAxisLabel: {
						show: true,
						textStyle: {
							color: '#ffffff'
						}
					}
				}
			};
		},
		components: {
			nodataImg
		},
		computed: {
			...Vuex.mapState('managerPlanList', ['statisticsParameter', 'expertScoreStatisticList', 'loading'])
		},
		activated() {
			this.clearDate();
			this.runFunc();
		},
		activated() {
			this.clearDate();
			this.runFunc();
		},
		methods: {
			...Vuex.mapActions('managerPlanList', ['GetExpertScoreStatistic']),
			datePicker(event) {
				if (event) {
					this.statisticsParameter.startdt = event[0];
					this.statisticsParameter.enddt = event[1];
				} else {
					this.clearDate();
				}
			},
			clearDate() {
				this.statisticsParameter.startdt = '';
				this.statisticsParameter.enddt = '';
			},
			search() {
				this.runFunc();
			},
			runFunc() {
				this.GetExpertScoreStatistic().then(res => {
					this.boxplotChart();
					this.lineChart();
				});
			},
			boxplotChart() {
				let dom = document.getElementById('boxplotChart'),
					Expertsdata = [],
					value = [],
					color = ['#248AFD'],
					myChart = echarts.init(dom),
					app = {},
					dataArr = [],
					option = null;
				if (this.expertScoreStatisticList.Experts && this.expertScoreStatisticList.Experts.length > 0) {
					this.expertScoreStatisticList.Experts.forEach(element => {
						Expertsdata.push(element.Scores);
						value.push(element.ExpertName);
					});
				}
				let data = echarts.dataTool.prepareBoxplotData(Expertsdata);
				for (let i = 0; i < Expertsdata.length; i++) {
					for (let j = 0; j < Expertsdata[i].length; j++) {
						dataArr.push([i, Expertsdata[i][j]]);
					}
				}
				option = {
					color: ['#3D73DD'],
					backgroundColor: '#282B32',
					tooltip: {
						trigger: 'item',
						axisPointer: {
							type: 'shadow'
						}
					},
					title: [{
						text: '报告质控评分',
						left: 'left',
						textStyle: {
							fontSize: 16,
							color: "#ffffff"
						},
					}],
					grid: {
						left: '1',
						right: '1',
						bottom: '1',
						top: '20%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: value,
						boundaryGap: true,
						nameGap: 30,
						splitArea: {
							show: false
						},
						axisLine: this.echartsOption.axisLine,
						axisLabel: this.echartsOption.xAxisAxisLabel,
						splitLine: {
							show: false
						}
					},
					yAxis: {
						type: 'value',
						name: '评分',
						nameTextStyle: {
							color: '#ffffff',
							align: 'right',
						},
						axisTick: {
							show: false
						},
						axisLine: this.echartsOption.axisLine,
						axisLabel: this.echartsOption.yAxisAxisLabel,
						splitLine: {
							show: true,
							lineStyle: {
								color: '#3D4049'
							}
						}
					},
					series: [{
							name: 'outlier',
							type: 'scatter',
							data: dataArr,
							symbolSize: 8,
							tooltip: {
								formatter: function(params, ticket, callback) {
									return `${params.name}:${params.data[1]}分`;
								}
							}
						},
						{
							name: 'boxplot',
							type: 'boxplot',
							data: data.boxData,
							boxWidth: [15, 15],
							itemStyle: {
								normal: {
									color: '#83A6EA',
									borderColor: '#ffffff',
									opacity: .8
								}
							},
							tooltip: {
								formatter: function(param) {
									return [
										param.name + ': ',
										'upper: ' + param.data[5],
										'Q3: ' + param.data[4],
										'median: ' + param.data[3],
										'Q1: ' + param.data[2],
										'lower: ' + param.data[1]
									].join('<br/>');
								}
							}
						}
					]
				};
				myChart.clear();
				myChart.setOption(option, true);
				myChart.resize(); //区域更新
				window.addEventListener('resize', () => {
					myChart.resize();
				});
			},
			lineChart() {
				let _this = this,
					data = [],
					value = [],
					color = ['#248AFD'],
					dom = document.getElementById('lineChart'),
					myChart = echarts.init(dom),
					app = {},
					option = null;
				if (this.expertScoreStatisticList.Experts && this.expertScoreStatisticList.Experts.length > 0) {
					this.expertScoreStatisticList.Experts.forEach(element => {
						value.push(element.ReportCount);
						data.push(element.ExpertName);
					});
				}

				option = {
					color: color,
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'none'
						},
						formatter: function(params, ticket, callback) {
							return `报告数: ${params[0].value}份`;
						},
					},
					title: [{
						text: '报告计数',
						left: '-1',
						textStyle: {
							fontSize: 16,
							color: "#ffffff"
						},
					}],
					grid: {
						left: '1',
						right: '1',
						bottom: '1',
						top: '25%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: data,
						triggerEvent: true,
						axisTick: {
							show: false
						},
						axisLine: this.echartsOption.axisLine,
						axisLabel: this.echartsOption.xAxisAxisLabel,
						splitLine: {
							show: false
						}
					},
					yAxis: {
						type: 'value',
						name: '计数',
						nameTextStyle: {
							color: '#ffffff',
							align: 'right',
						},
						axisTick: {
							show: false
						},
						axisLine: this.echartsOption.axisLine,
						axisLabel: this.echartsOption.yAxisAxisLabel,
						splitLine: {
							show: false
						}
					},
					series: [{
						barMaxWidth: 8,
						name: '专家',
						type: "bar",
						itemStyle: {
							normal: {
								barBorderRadius: [20, 20, 20, 20],
								lineStyle: {
									width: 1 //设置线条粗细
								}
							}
						},
						label: {
							show: true,
							color: '#fff',
							position: 'top',
							fontSize: 12
						},
						data: value,
					}]
				};
				myChart.clear();
				myChart.setOption(option, true);
				myChart.resize(); //区域更新
				window.addEventListener('resize', () => {
					myChart.resize();
				});
			}
		}
	};
</script>
